import React, { useEffect, useState, forwardRef } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

const DeleteSetup  = forwardRef(({selectedSetup, setDeleteModalState, deleteSetup}, ref) => {

    const [newSetupOpen, setNewSetupOpen] = useState(false);

    const deleteSelectedSetup = () => {
        deleteSetup();
        setDeleteModalState(false);//close modal
    }

    function getSetupName(setup){

        let clubString = "";
        if (setup.ClubName === "Prototype") {

            if(setup.ClubDescription){
                clubString = setup.ClubDescription + (setup.ClubId ? ` [${setup.ClubId}]` : "");
            }else{
                clubString = setup.ClubName + (setup.ClubId ? ` [${setup.ClubId}]` : "");
            }
        } else if (setup.ClubName === "Custom") {
            clubString = setup.ClubName + (setup.ClubId ? ` [${setup.ClubId}]` : "");
        } else {
            clubString = setup.ClubName;
        }

        return clubString;
    }

    return(
<div className='modal-container' style={{height:"250px", maxWidth:"450px"}}>
    <button className='modal-close-button' onClick={() => setDeleteModalState(false)}><Cross2Icon width='30px' height='30px'/></button>
    <div className='modal-header'>Delete Setup</div>
    <div className='modal-content'>
        <div style={{fontSize:'18px'}}>Are you sure you want to delete the setup?</div>
        <div style={{fontSize:'16px', marginTop:'10px'}}>{getSetupName(selectedSetup)}</div>
    </div>
    <div className="modal-footer" >
        <button className="button" style={{width:'100px'}} onClick={() => deleteSelectedSetup()}>Yes</button>
    </div>
</div>
    );
});

export default DeleteSetup;